import { Skeleton, Grid2 as Grid } from '@mui/material'

const MedicalInfoSkeleton = () => {
  return (
    <Grid container direction={'column'}>
      <Skeleton sx={{ padding: '1rem', margin: 0 }} />
      <Skeleton sx={{ padding: '1rem', margin: 0 }} />
    </Grid>
  )
}

export default MedicalInfoSkeleton
